export default "__VITE_ASSET__CdLLxlJf__"